const notification = {
  notifications: [],
  add(title, content, success = true) {
    this.notifications.push({
      success,
      title,
      content,
      show: false,
    });
    Alpine.nextTick(() => {
      this.notifications[this.notifications.length - 1].show = true;
    });
  },
  remove(index) {
    this.notifications[index].show = false;

    setTimeout(() => {
      delete this.notifications[index];
    }, 300);
  },
};

export default notification;
